// Small, reusable UI primitives used across the budget dashboard.
import React from "react";

export const Card = ({ className = "", children, testId, delay = 0 }) => (
  <div
    data-testid={testId}
    className={`fade-up bg-white rounded-2xl border border-[#D8D6D0] shadow-[0_1px_3px_rgba(26,28,26,0.04)] hover:shadow-[0_8px_24px_rgba(26,28,26,0.06)] hover:-translate-y-0.5 transition-all duration-300 ${className}`}
    style={{ animationDelay: `${delay}ms` }}
  >
    {children}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, sub, accent, testId, delay }) => (
  <Card className="p-6" testId={testId} delay={delay}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#5A5C58] font-medium">{label}</p>
        <p
          className="font-display text-3xl sm:text-4xl font-semibold mt-3 text-[#1A1C1A]"
          data-testid={`${testId}-value`}
        >
          {value}
        </p>
        {sub && <p className="text-sm text-[#5A5C58] mt-1">{sub}</p>}
      </div>
      <div
        className="w-11 h-11 rounded-full flex items-center justify-center"
        style={{ background: `${accent}22`, color: accent }}
      >
        <Icon size={20} strokeWidth={2} />
      </div>
    </div>
  </Card>
);

export const ProgressBar = ({ value, max, color = "#5F7161", over = false }) => {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div className="w-full h-2 rounded-full bg-[#EFEDE7] overflow-hidden">
      <div
        className="h-full rounded-full transition-all duration-500"
        style={{ width: `${pct}%`, background: over ? "#E27D60" : color }}
      />
    </div>
  );
};

export const NumberInput = ({ value, onChange, testId, prefix = "$" }) => (
  <div className="relative">
    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5A5C58] text-sm font-mono">
      {prefix}
    </span>
    <input
      data-testid={testId}
      type="number"
      min="0"
      step="1"
      value={value}
      onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))}
      className="w-full bg-white border border-[#D8D6D0] rounded-xl pl-7 pr-3 py-2 text-right font-mono text-[15px] text-[#1A1C1A] focus:outline-none focus:ring-2 focus:ring-[#5F7161]/40 focus:border-[#5F7161] transition-all"
    />
  </div>
);
